import React from "react";

export const ActionButton = ({ onClick, text, loading }) => {
	return (
		<button
			onClick={onClick}
			className={`button h-button is-primary is-big is-raised ${
				loading ? "is-loading" : ""
			}`}
		>
			{text}
		</button>
	);
};
